<template>
  <div class="px-2 px-lg-5">
    <loader v-if="loading || workoutLoading"></loader>
    <div class="summary-items d-flex justify-content-start mb-5">
      <div class="summary-items-container d-flex  text-center w-100">
        <div
          class="mr-1 mr-sm-2 mr-md-4 d-flex d-md-block flex-column justify-content-start align-items-center"
        >
          <radial-progress-bar
            :diameter="diameter"
            :completed-steps="
              getBarometerSteps(parseInt(summary.avgAccuracy), 100)
            "
            :total-steps="100"
            :startColor="fill(summary.avgAccuracy)"
            :stopColor="fill(summary.avgAccuracy)"
            :inner-stroke-color="'#cfcfcf'"
            :strokeWidth="strokeWidth"
            :innerStrokeWidth="strokeWidth"
            ><span class="font-23 font-weight-bold">
              {{ summary.avgAccuracy }}%
            </span>
            <img
              src="../assets/images/circle.svg"
              height="15"
              width="15"
              alt
              srcset
            /><img
              style="margin-top: -11px;margin-right: -1px;"
              src="../assets/images/dot.svg"
              alt
              srcset
            /> </radial-progress-bar
          ><span class="font-16 font-weight-500 line-height-24"
            >{{ t('average_accuracy') }}</span
          >
        </div>
        <div
          class="mr-1 mr-sm-2 mr-md-4 d-flex d-md-block flex-column justify-content-start align-items-center"
          v-if="showCalories"
        >
          <radial-progress-bar
            :diameter="diameter"
            :completed-steps="
              getBarometerSteps(
                parseInt(summary.totalCalories),
                weeklyGoalCalories
              )
            "
            :total-steps="weeklyGoalCalories"
            startColor="#009444"
            stopColor="#009444"
            :inner-stroke-color="'#cfcfcf'"
            :strokeWidth="strokeWidth"
            :innerStrokeWidth="strokeWidth"
            ><span class="font-23 font-weight-bold">
              {{ Math.round(summary.totalCalories) }}
            </span>
            <img
              src="../assets/images/calories.svg"
              height="15"
              width="15"
              alt
              srcset
            />
          </radial-progress-bar>
          <span class="font-16 font-weight-500 line-height-24"
            >{{ t('total_calories_burnt') }}</span
          >
        </div>
        <div
          class="mr-1 mr-sm-2 mr-md-4 d-flex d-md-block flex-column justify-content-start align-items-center"
          v-if="!showCalories"
          >
          <radial-progress-bar
            :diameter="diameter"
            :completed-steps="
              getBarometerSteps(
                parseInt(summary.weeklyWorkoutCount),
                weeklyGoalCount
              )
            "
            :total-steps="weeklyGoalCount"
            startColor="#009444"
            stopColor="#009444"
            :inner-stroke-color="'#cfcfcf'"
            :strokeWidth="strokeWidth"
            :innerStrokeWidth="strokeWidth"
            ><span class="font-23 font-weight-bold">
              {{ Math.round(summary.weeklyWorkoutCount) }}
            </span>
            <img
              src="../assets/images/calories.svg"
              height="15"
              width="15"
              alt
              srcset
            />
          </radial-progress-bar>
          <span class="font-16 font-weight-500 line-height-24"
            >{{ t('weekly_workout_count') }}</span
          ><br>
        </div>
        <div
          class="mr-1 mr-sm-2 mr-md-4 d-flex d-md-block flex-column justify-content-start align-items-center"
        >
          <radial-progress-bar
            :diameter="diameter"
            :completed-steps="
              getBarometerSteps(parseInt(summary.workoutTime), weeklyGoalTime)
            "
            :total-steps="weeklyGoalTime"
            startColor="#009444"
            stopColor="#009444"
            :inner-stroke-color="'#cfcfcf'"
            :strokeWidth="strokeWidth"
            :innerStrokeWidth="strokeWidth"
            ><span class="font-23 font-weight-bold">{{
              convertToMins(summary.workoutTime)
            }}</span
            ><img
              src="../assets/images/circle.svg"
              height="15"
              width="15"
              alt
              srcset
            />
            <img
              style="margin-top: -12px;margin-right: 1px;"
              src="../assets/images/timearrow.svg"
              alt
              srcset
            /> </radial-progress-bar
          ><span class="font-16 font-weight-500 line-height-24"
            >{{ t('total_workout_time') }}</span
          >
        </div>
      </div>
    </div>

    <div class="user-data d-flex justify-content-start ml-1">
      <div class="joined px-2 px-md-3 py-1 py-md-2 mr-2 mr-md-4">
        <label
          class="font-12 font-weight-bold line-height-18 text-gray text-uppercase mobile-joined"
          >{{ t('joined_on') }}</label
        ><br />
        <label
          class="font-16 font-weight-bold line-height-24 mobile-joined-date"
        >
          {{ toDateFormatMonthName(joinDate) }}
        </label>
      </div>
      <div class="total px-2 px-md-3 py-1 py-md-2">
        <label
          class="font-12 font-weight-bold line-height-18 text-gray text-uppercase mobile-total-label"
          >{{ t('total_workouts') }}</label
        ><br />
        <label class="font-16 font-weight-bold line-height-24 mobile-total">{{
          totalRows
        }}</label>
      </div>
    </div>
    <div class="workout-history mx-1 mt-4 w-100">
      <div v-if="totalRows > 0">
        <div class="overflow-auto w-100 d-none d-md-block">
          <b-table
            small
            responsive
            :items="workoutHistory"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            tbody-tr-class="row-class"
            thead-tr-class="row-class row-class-header"
          >
            <template v-slot:cell(Workout)="row">
              <div class="d-flex justify-content-start align-items-center pl-2">
                <div class="video-thumbnail pl-0 w-auto ">
                  <b-img :src="row.item.thumbnail" class="rounded"></b-img>
                </div>
                <div class="video-name text-left ml-1">
                  <p
                    class="tanentNameSec font-14 line-height-21 font-weight-bold"
                    :class="{'notranslate' : !row.item.needTranslation}"
                    v-b-tooltip.hover
                    :title="row.item.videoTitle"
                  >
                    {{
                      row.item.videoTitle.length > 25
                        ? row.item.videoTitle.toString().substring(0, 25) +
                          "..."
                        : row.item.videoTitle
                    }}
                  </p>
                  <p class="color-primary tanentNameSec">
                    {{ row.item.tenantName }}
                  </p>
                </div>
              </div>
            </template>
            <template v-slot:cell(Actions)="row">
              <div
                class="color-primary d-flex justify-content-start align-items-center ef-cursor-pointer"
                @click="tryAgain(row.item)"
              >
                <p class=" m-0">{{ t('try_again') }}</p>
              </div>
            </template>
            <template v-slot:cell(Date)="row">
              <div class="d-block text-gray">
                {{ toDateFormatter(row.item.workoutDate) }}
              </div>
            </template>
            <template v-slot:cell(workoutTime)="row">
              <div class="d-block text-gray">
                {{ convertToMins(row.item.workoutTime) }}
              </div>
            </template>
            <template v-slot:cell(accuracy)="row">
              <div class="d-block">
                <span v-if="row.item.repCount">
                  {{ row.item.repCount }} Reps
                </span>
                <span v-else>
                  {{
                    row.item.accuracy == "NaN"
                    ? 0
                    : Math.round(row.item.accuracy)
                  }}%
                  </span>
              </div>
            </template>
            <template v-slot:cell(calories)="row" v-if="showCalories">
              <div class="d-block">
                {{
                  row.item.accuracy == "NaN" ? 0 : Math.round(row.item.calories)
                }}
              </div>
            </template>
          </b-table>
        </div>

        <div
          class="d-flex d-md-none justify-content-start align-items-center w-100"
        >
          <label
            class="p-2 flex-fill text-gray font-weight-bold font-12 line-height-18 no-margin flex-item"
            >{{ t('date') }}</label
          >

          <label
            class="p-2 flex-fill text-gray font-weight-bold font-12 line-height-18 no-margin flex-item"
            >{{ t('accuracy') }}</label
          >
          <label
            class="p-2 flex-fill text-gray font-weight-bold font-12 line-height-18 no-margin flex-item"
            v-if="showCalories"
            >{{ t('calories') }}</label
          >
          <label
            class="p-2 flex-fill text-gray font-weight-bold font-12 line-height-18 no-margin flex-item"
            >{{ t('workout_time') }}</label
          >
        </div>
        <div
          class="d-flex d-md-none flex-column justify-content-start align-items-center table-container mb-2"
          v-for="(item, i) in itemsForList"
          :key="i"
        >
          <div class="d-flex d-md-none align-items-center w-100">
            <label
              class="p-2 mb-0 flex-fill  text-gray font-weight-500 font-12 line-height-18 flex-item"
              >{{ toDateFormatter(item.workoutDate) }}</label
            >

            <label class="p-2 mb-0  flex-fill font-weight-500 font-12 line-height-18 flex-item"
              >{{
                  item.accuracy == "NaN"
                    ? 0
                    : Math.round(item.accuracy)
                }}%</label
            >
            <template v-if="showCalories">
              <label class="p-2 mb-0  flex-fill font-weight-500 font-12 line-height-18 flex-item"
                >{{
                    item.accuracy == "NaN" ? 0 : Math.round(item.calories)
                  }}</label
              >
            </template>
            <label
              class="p-2  mb-0  flex-fill text-gray font-weight-500 font-12 line-height-18 flex-item"
              >{{ convertToMins(item.workoutTime) }}</label
            >
          </div>
          <div class="d-flex justify-content-around thumbnail-container my-2">
            <div class="d-flex justify-content-start align-items-center image-container">
                <div class="video-thumbnail p-2 mr-3 flex-item">
                  <b-img :src="item.thumbnail"></b-img>
                </div>
                <div class="d-flex flex-column justify-content-center font-12 line-height-18 font-weight-bold flex-item">
                  <label
                    class="font-12 line-height-18 font-weight-bold m-0"
                    v-b-tooltip.hover
                    :title="item.videoTitle"
                  >
                    {{
                      item.videoTitle.length > 15
                        ? item.videoTitle.toString().substring(0, 15) +
                          "..."
                        : item.videoTitle
                    }}
                  </label>
                  <label class="color-primary font-12 line-height-18 font-weight-bold m-0"
                  v-b-tooltip.hover
                    :title="item.tenantName">
                    {{ item.tenantName.length > 15 ? item.tenantName.toString().substring(0, 15) 
                    + "..." : item.tenantName}}
                  </label>
                </div>
              </div>
              <div
                class="color-primary d-flex justify-content-start align-items-center try-again-button"
                @click="tryAgain(item)"
              >
                <label class="font-12 line-height-18 font-weight-bold m-0 ef-cursor-pointer">{{ t('try_again') }}</label>
              </div>
            </div>
        </div>
        <b-row
          class="d-flex justify-content-center align-items-center paginationSec"
        >
          <b-col cols="4" class="col-sm-8 col-lg-5">
            <b-pagination
              size="sm"
              pills
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="my-table"
              id="perPageSelect"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { i18nComponentMixin } from "@/i18n/mixin";
const {
  mapState,
  mapActions,
} = createNamespacedHelpers("user/userProfile");

const { mapActions: b2bActions } = createNamespacedHelpers(
  "b2bUser"
);

import RadialProgressBar from "vue-radial-progress";

export default {
  components: {
    RadialProgressBar,
  },
  data: function() {
    return {
      startColor: "#ed1c24",
      middleColor: "#FFC700",
      stopColor: "#009444",
      sortBy: "id",
      sortDesc: true,
      perPage: 20,
      perPageOptions: [5, 10, 15,20],
      currentPage: 1,
      viewportWidth: window.innerWidth,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      userInfo: this.$store.state.userInfo,
      showCalories : true,
      // diameter: 150
    };
  },
  mixins:[i18nComponentMixin('views/UserProgress')],
  computed: {
    ...mapState([
      "summary",
      "workoutHistory",
      "loading",
      "workoutLoading",
      "joinDate",
    ]),
    itemsForList() {
      return this.workoutHistory.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage,
      );
    },
    diameter() {
      //let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      if (this.viewportWidth < 600) {
        return 100;
      } else {
        return 150;
      }
    },
    strokeWidth() {
      if (this.viewportWidth < 600) {
        return 6;
      } else {
        return 8;
      }
    },
    isMobile() {
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      return isAndroid || isiOS;
    },
    fields() {
      return this.showCalories
        ? [
            { key: "Workout", label: this.t("Workout") },
            { key: "accuracy", label: this.t("Accuracy/Rep") },
            this.showCalories ? { key: "calories", label: this.t("calories") } : null,
            { key: "workoutTime", label: this.t("workoutTime") },
            { key: "Date", label: this.t("Date") },
            { key: "Actions", label: this.t("Actions") },
          ].filter(Boolean) // Removes any null values
        : [
            { key: "Workout", label: this.t("Workout") },
            { key: "accuracy", label: "" },
            { key: "workoutTime", label: this.t("workoutTime") },
            { key: "Date", label: this.t("Date") },
            { key: "Actions", label: "" },
          ];
    },



    totalRows() {
      return this.workoutHistory ? this.workoutHistory.length : 0;
    },

    weeklyGoalTime() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      return +userInfo?.targetMinutes ? +userInfo?.targetMinutes * 60 : 60;
    },
    weeklyGoalCalories() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      return +userInfo?.targetCalories ? +userInfo?.targetCalories : 1000;
    },
    weeklyGoalCount() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      return +userInfo?.targetCount ? +userInfo?.targetCount : 15;
    },
  },

  methods: {
    ...mapActions(["loadUserWorkoutSummary", "loadWorkoutData"]),
    ...b2bActions(["setIsTitle", "setTitle"]),
    convertToMins(durationSecs) {
      durationSecs = parseInt(durationSecs);
      var hours = Math.floor(durationSecs / 3600);
      var minutes = Math.floor((durationSecs - hours * 3600) / 60);
      var seconds = durationSecs - hours * 3600 - minutes * 60;
      if (hours == 0) {
        return ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
      }

      return (
        ("0" + hours).slice(-2) +
        ":" +
        ("0" + minutes).slice(-2) +
        ":" +
        ("0" + seconds).slice(-2)
      );
    },
    getBarometerSteps(newSteps, totalSteps) {
      return newSteps > totalSteps ? totalSteps : newSteps;
    },
    fill(score){
      if(Number(score) < 34.99) {
        return this.startColor
      } else if (Number(score) < 64.99) {
        return this.middleColor
      } else {
        return this.stopColor;
      }
    },

    toDateFormatMonthName(dateTime) {
      if (dateTime) {
        const date = new Date(dateTime);
        let day = "" + date.getDate();
        if (day.length < 2) {
          day = "0" + day;
        }
        return (
          day + " " + this.months[date.getMonth()] + " " + date.getFullYear()
        );
      }
    },

    toDateFormatter(dateTime) {
      const date = new Date(dateTime);
      let day = "" + date.getDate();
      if (day.length < 2) {
        day = "0" + day;
      }
      let month = "" + (date.getMonth() + 1);
      if (month.length < 2) {
        month = "0" + month;
      }
      return day + "." + month + "." + date.getFullYear();
    },

    tryAgain(item) {
      this.$router.push(
        "/workout/" +
          item.tenantName.replace(" ", "") +
          "?id=" +
          item.videoId +
          "&tryNow=true"
      );
    }
  },

  async mounted() {
    this.showCalories = !this.userInfo?.corporate?.config?.disableCalories;
    this.loadUserWorkoutSummary();
    this.loadWorkoutData();
    this.setIsTitle(true);
    this.setTitle("Progress");
  },
  beforeDestroy() {
    this.setIsTitle(false);
    this.setTitle("");
  },
};
</script>

<style lang="scss" scoped>
::v-deep .page-item .page-link {
  background-color: none !important;
  border-color: none !important;
  color: #969b92;
}
::v-deep .page-item.active .page-link {
  background-color: #73bc44 !important;
  border-color: #73bc44 !important;
  font-weight: bold !important;
  color: #ffffff !important;
}

::v-deep table {
  border-collapse: separate;
  border-spacing: 0 5px;
  text-align: center;
}
::v-deep table th {
  border: 0;
  text-align: left !important;
  color: #969b92 !important;
}

::v-deep table td {
  background: #ffffff;
  height: 30px;
  vertical-align: middle;
  border-top: 1px solid #d0e0c8;
  border-bottom: 1px solid #d0e0c8;
}

::v-deep table td:first-of-type {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-left: 1px solid #d0e0c8;
}

::v-deep table td:last-of-type {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-right: 1px solid #d0e0c8;
}
.pagination {
  justify-content: center;
}
.video-Title {
  width: 170px;
}

.font-small {
  font-family: "Poppins-Semi-Bold";
}

.video-thumbnail {
  img {
    height: 60px;
    width: 100px;
  }
}
.video-name {
  p {
    margin-bottom: 0 !important;
  }
}

.joined,
.total {
  border: 3px solid #d0e0c8;
  border-radius: 6px;
}

@media screen and (max-width: 768px) {
  .no-margin {
    margin-bottom: 0;
  }
  .table-container {
    background: #ffffff;
    border: 1px solid #d0e0c8;
    box-sizing: border-box;
    border-radius: 6px;
    width: 100% !important;
  }
  .thumbnail-container {
    background: #F4F6F9;
    border-radius: 6px;
    width: 97% !important;
  }
  .mobile-joined,
  .mobile-total-label {
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
  }
  .mobile-joined-date,
  .mobile-total {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
  }

  .flex-item {
    flex: 1 !important; 
    text-align: center;
  }

  .thumbnail-container{
    justify-content: center !important;
  }
  .image-container{
    flex: 2;
  }

  .try-again-button{
    flex: 1;
    label{
      text-align: center;
      width: 100%;
    }
  }

  .user-data{
    justify-content: center !important;
  }
}

@media screen and (max-width: 576px) {
  .summary-items {
    justify-content: center !important;
  }
  .summary-items-container {
    justify-content: space-around !important;
    align-items: center !important;
    span {
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
    }
  }
  .mobile-joined,
  .mobile-total-label {
    font-weight: bold;
    font-size: 10px;
    line-height: 15px;
  }
  .mobile-joined-date,
  .mobile-total {
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
  }
}

</style>
